import { tv } from "@ui/lib/tv";
import { MarketplaceSearchField } from "./MarketplaceSearchField";

const marketplaceSearchBar = tv({
  base: ["flex h-[52px] items-center rounded-full bg-white px-3", "shadow-md"],
});

export interface MarketplaceSearchBarProps {
  onChange: (value: string) => void;
  value: string;
}

/** Standalone rounded search pill — used by the mobile Explore search overlay. The
 *  desktop marketplace bar embeds `MarketplaceSearchField` directly in the shared
 *  `SearchBar` shell instead, so the input and the Sort/Filters pills read as one bar. */
export function MarketplaceSearchBar({ onChange, value }: MarketplaceSearchBarProps) {
  return (
    <div className={marketplaceSearchBar()}>
      <MarketplaceSearchField onChange={onChange} value={value} />
    </div>
  );
}
